module.exports = __webpack_public_path__ + "img/case3-1.70ff2793.png";